import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTheme } from "@mui/material";
import {
  addDetailsAPI,
  botProfilesAPI,
  publishDetailsAPI,
  updateDetailsAPI,
} from "./utils/constants";
import dayjs from "dayjs";
import EditDetails from "./popups/editDetails";
import { useKBState } from "./customHooks/useKBState";
import * as XLSX from "xlsx";

interface LearningDashboardProps {
  botDetailsData: any;
  onSubmit: (e: any) => void;
  onPageClick: (e: any, formV: any) => void;
  exportAsXlsx: (totalRecords: any, formV: any) => void;
}

type RefsType = {
  userIssue: (HTMLParagraphElement | null)[][];
  workNotes: (HTMLParagraphElement | null)[][];
  resolutionNotes: (HTMLParagraphElement | null)[][];
  botResolution: (HTMLParagraphElement | null)[][];
  publishedContent: (HTMLParagraphElement | null)[][];
};

export const formatDate = (
  date?: string | Date,
  format: string = "YYYY-MM-DD"
): string => {
  return dayjs(date || new Date()).format(format);
};

const LearningDashboardSection: React.FC<LearningDashboardProps> = ({
  botDetailsData,
  onSubmit,
  onPageClick,
  exportAsXlsx,
}) => {
  const { val, setVal } = useKBState();
  const [rowData, setRowData] = useState<any[]>(
    botDetailsData?.result?.map((item: any) => ({
      ...item,
      reviewerResolution: "",
      kb: "",
      reviewer: "",
    }))
  );

  // const [editDetailsPopup, setEditDetailsPopup] = useState(false);
  // const [addKbText, setAddKbText] = useState("");
  // const [updatedKbText, setUpdatedKbText] = useState("");

  useEffect(() => {
    console.log("printing botdetails..",botDetailsData)
    const newRowData = botDetailsData?.data?.map((item: any) => ({
      ...item,
      reviewerResolution: "",
      kb: "",
      reviewer: "",
    }));
    console.log("rowdata", rowData);
    setRowData(newRowData);
    setVal({ ...val, getReportLoader: false });

    if (botDetailsData && botDetailsData.length !== 0) {
      setPageLoader(false);
    }
  }, [botDetailsData]);

  const theme = useTheme();
  const color = theme.palette.mode;
  const [formValues, setFormValues] = useState({
    startDate: formatDate(),
    endDate: formatDate(),
    selectedBotId: "B0001",
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const [pageLoader, setPageLoader] = useState(true);
  const [isCopied, setIsCopied] = useState(null);
  const [viewMore, setViewMore] = useState<any | null>(null);
  const [isOverflowing, setIsOverflowing] = useState<boolean[]>([]);
  const [visibleRows, setVisibleRows] = useState<any>({
    userIssue: [],
    workNotes: [],
    resolutionNotes: [],
    botResolution: [],
    publishedContent: [],
  });

  const options2 = [
    { value: "extra_info", label: "Extra Information" },
    { value: "new_customKb", label: "New Custom KB" },
  ];
  const options1 = [
    { value: "excl", label: "Excellent" },
    { value: "avg", label: "Average" },
    { value: "noth", label: "Not Helpful" },
  ];

  //   const filteredItems = botDetailsData?.result?.filter((item: any) =>
  //   item.KB_details?.some((kb: any) => kb.is_helpful === "negative")
  // );

  const [currPage, setCurrPage] = useState(1);
  let cp = currPage * 10;
  const lastIndx =
    cp > botDetailsData?.totalRecords ? botDetailsData?.totalRecords : cp;
  const frstIndx =
    lastIndx % 10 == 0 ? lastIndx - 9 : lastIndx - (lastIndx % 10) + 1;
  const totalPages = Math.ceil(botDetailsData?.totalRecords / 10);

  const chngePage = async (page: any) => {
    console.log("changing to page", page);
    if (page >= 1 && page <= totalPages) {
      setCurrPage(page);
      onPageClick(page, formValues);
    }
    console.log("cuurent", currPage);
  };

  const prevPage = async () => {
    if (currPage != 1) {
      setCurrPage(currPage - 1);
    }
    onPageClick(currPage - 1, formValues);
  };
  const nxtPage = async () => {
    if (currPage != totalPages) {
      setCurrPage(currPage + 1);
    }
    onPageClick(currPage + 1, formValues);
  };

  const publishDetails = async () => {
    setVal({ ...val, publishloader: true });

    try {
       const formData = new FormData();
      formData.append("actions", "recreate_index");
      formData.append("method", "GET");
      const options = {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body:formData
      };

      const response = await fetch(publishDetailsAPI, options);

      console.log("raw response in learning dashboard", response);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      console.log("get publish details result", result);

      if (result) {
        setVal({
          ...val,
          publishloader: false,
          openPublishPopup: false,
        });

        handleShowToast(result, "success");
      } else {
        alert("Not Found");
        setVal({ ...val, publishloader: false });
      }
    } catch (error) {
      console.error("publishDetails API error:", error);

      setVal({
        ...val,
        publishloader: false,
      });
    }
  };

  const handleShowToast = (value: any, type: any) => {
    setShowToast(true);
    setToastMessage(value);
    setToastType(type);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
      setToastType("");
    }, 4000);
  };

  // const paginatedData = botDetailsData.data.slice(
  //   (currPage - 1) * cp,
  //   currPage * cp
  // );

  const renderPageNumbers = (): JSX.Element[] => {
    const pages: any = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(renderPageButton(i));
      }
    } else {
      pages.push(renderPageButton(1));
      if (currPage > 3) {
        console.log("inside");

        pages.push(
          <li className="page-item disabled" key="start-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }

      // const startPage = Math.max(2, currPage -1);
      // const endPage = Math.min(totalPages - 1, currPage - 1);
      // console.log('start page, endpage', startPage, endPage);

      const middlePages: number[] = [];
      if (currPage <= 3) {
        middlePages.push(2, 3, 4);
      } else if (currPage >= totalPages - 2) {
        middlePages.push(totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        middlePages.push(currPage - 1, currPage, currPage + 1);
      }

      middlePages.forEach((page) => {
        if (page > 1 && page < totalPages) {
          pages.push(renderPageButton(page));
        }
      });

      // for(let i = startPage; i <= endPage; i++){
      //   pages.push(renderPageButton(i));
      // }

      if (currPage < totalPages - 2) {
        pages.push(
          <li className="page-item disabled" key="end-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }

      pages.push(renderPageButton(totalPages));
    }

    return pages;
  };

  const renderPageButton = (page: number) => {
    return (
      <li
        key={page}
        className={`page-item ${currPage === page ? "active" : ""}`}
      >
        <button
          className="page-link"
          style={{ width: "38px", fontSize: "14px" }}
          onClick={() => chngePage(page)}
        >
          {page}
        </button>
      </li>
    );
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const handleBotSelect = (id: string | null) => {
    if (id) {
      setFormValues({
        ...formValues,
        selectedBotId: id,
      });
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log(
      "start date and end date",
      formValues.startDate,
      formValues.endDate
    );
    setVal({ ...val, getReportLoader: true });
    onSubmit(formValues);
  };

  const handleUpdateClick = (item: any, convid: any) => {
    console.log('whole ITEM ' , item);
    console.log(
      "handle update click",
      item?.kb,
      item?.reviewer,
      item?.reviewerResolution
    );

    if (
      item?.kb.length == 9 &&
      item?.reviewerResolution !== "" &&
      item?.reviewer !== "" &&
      item?.reviewer !== "Select" &&
      item?.reviewer === "extra_info"
    ) {
      handleUpdate(item, convid);
    } else if (
      item?.reviewer !== "" &&
      item?.reviewer !== "Select" &&
      item?.reviewer !== "extra_info" &&
      item?.reviewerResolution !== ""
    ) {
      addDetails(item, convid);
    } else {
      handleShowToast(
        "Please fill the reviewer resolution, mention kb and reviewer selection",
        "danger"
      );
      setLoadingIndex(null);
    }
  };

  const handleUpdate = async (val: any, convid: any) => {
    try {
      const payload = JSON.stringify({
        kb_number: val.kb.toUpperCase(),
        extra_info: val.reviewerResolution,
        convid: convid,
      });
      const formData = new FormData();
      formData.append("actions", "update_kb");
      formData.append("method", "POST");
      formData.append("kb_number", val.kb.toUpperCase());
      formData.append("extra_info", val.reviewerResolution);
      formData.append("convid", convid);

      const options = {
        method: "POST",
      
        
        // body: JSON.stringify({
        //   "kb_number": val.kb.toUpperCase(),
        //   "extra_info": val.reviewerResolution,
        //   "convid": convid
        // }),
        body:formData
      };
      const result = await (await fetch(`${updateDetailsAPI}`, options)).json();
      console.log("get update details result", result);

      if (result) {
        if (result.success) {
          setLoadingIndex(null);
          handleShowToast(result.success, "success");
        }
      } else {
        alert("Not Found");
      }
    } catch (error) { }
  };

  const addDetails = async (val: any, convid: any) => {
    try {
      const payload = JSON.stringify({
        extra_info: "extra",
        enriched_data: val.reviewerResolution,
        convid: convid,
      });

      const formData = new FormData();
      formData.append("actions", "new_kb_create");
      formData.append("method", "POST");
      formData.append("extra_info", val.reviewer);
      formData.append("enriched_data", val.reviewerResolution);
      formData.append("convid", convid);

      const options = {
        method: "POST",
        
        body: formData,
      };
      const result = await (await fetch(`${addDetailsAPI}`, options)).json();
      console.log("get update details result", result);

      if (result) {
        setLoadingIndex(null);
        handleShowToast(
          result.ans.message + " " + result.ans.number,
          "success"
        );
      } else {
        alert("Not Found");
      }
    } catch (error) { }
  };

  const exportChatTranscript = () => {
    const ws = XLSX.utils.json_to_sheet(val.transcript);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    });

    const url = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `transcript-${formValues.startDate}-${formValues.endDate}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const copyToClipboard = (text: string, index: any) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setIsCopied(index);
        setTimeout(() => {
          setIsCopied(null);
        }, 2000);
      })
      .catch((err) => {
        console.log("failed to copy", err);
      });
  };

  // const resolutionTdRef = useRef<any>(null);
  // const textareaRef = useRef<any>(null);
  const hasSetHeight = useRef(false);
  const textRef = useRef<RefsType>({
    userIssue: [],
    workNotes: [],
    resolutionNotes: [],
    botResolution: [],
    publishedContent: [],
  });


  const getBotResolutionText = () => {
    const botresolutiontext = botDetailsData?.result?.map(
      (d: any) => d.botResolution
    );
    return botresolutiontext;
  };

  // useEffect(() => {
  //   if (
  //     resolutionTdRef.current &&
  //     textareaRef.current &&
  //     !hasSetHeight.current
  //   ) {
  //     const height = resolutionTdRef.current.offsetHeight;
  //     textareaRef.current.style.height = `${height}px`;
  //     hasSetHeight.current = true;
  //   }
  // }, [getBotResolutionText]);

  // const checkforOverflow = (col: keyof RefsType, index: number) => {
  //   if (textRef) {
  //     const ref = textRef.current[col][index]?.[0];
  //     if (ref) {
  //       console.log("check for overflow works", ref);
  //       return ref.scrollHeight > ref.clientHeight;
  //     } else {
  //       return false;
  //     }
  //   }
  // };



  const checkOverflow = () => {
    console.log("text ref", textRef, textRef.current);
    const tempArr: any = [];
    if (textRef && textRef.current) {
      // const newOverflow = textRef.current.map((ref: any) => {
      //   // console.log('ref', ref)
      //   if (ref ) {
      //     console.log('ref', ref, ref.scrollHeight , ref.clientHeight)
      //     return ref.scrollHeight > ref.clientHeight
      //   }
      //   return false;
      // })
      // const newOverflow1 = textRef.current.map((ref: any) => {
      //   if (ref ) {
      //     console.log('ref', ref, ref.scrollHeight , ref.clientHeight)
      //     if (ref.scrollHeight > ref.clientHeight){
      //       tempArr.push({
      //         index: ref.index,
      //         name: ref.name,
      //         showViewMore: true
      //       })
      //     }
      //   }
      // })
      // console.log('temp arr', tempArr)
      // setIsOverflowing(newOverflow);
    }
  };

  useEffect(() => {

    botDetailsData?.result?.forEach((_: any, index: any) => {
      Object.keys(textRef.current).forEach((col) => {
        if (!textRef.current[col as keyof RefsType][index]) {
          textRef.current[col as keyof RefsType][index] = [];
        }
        if (!visibleRows[col as keyof RefsType][index]) {
          if (!visibleRows[col as keyof RefsType]) {
            visibleRows[col as keyof RefsType] = [];
          }
          visibleRows[col as keyof RefsType][index] = [false];
        }
      });
    });

    setTimeout(() => {
      const updatedVisibility = { ...visibleRows };
      botDetailsData?.result?.forEach((_: any, index: any) => {
        Object.keys(textRef.current).forEach((col) => {
          const ref = textRef.current[col as keyof RefsType][index]?.[0];
          if (ref) {
            updatedVisibility[col as keyof RefsType][index][0] = ref.scrollHeight > ref.clientHeight;
          } else {
            return false;
          }
        })
      });
      setVisibleRows(updatedVisibility)
    }, 0)





    // checkOverflow();

    // window.addEventListener("resize", checkOverflow);

    // return () => window.removeEventListener("resize", checkOverflow);
  }, [botDetailsData]);

  // fetching bot profile

  // useEffect(() => {
  //   // Fetch bot profiles from the REST API
  //   const fetchBotProfiles = async () => {
  //     try {
  //       const options = {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       };
  //       const response = await (
  //         await fetch(`${botProfilesAPI}`, options)
  //       ).json();

  //       if (!response && !Array.isArray(response)) return;
  //       const filteredSortedIds = response
  //         .filter((bot: any) => bot.id.toLowerCase().startsWith("b00"))
  //         .map((bot: any) => bot.id)
  //         .sort((a: any, b: any) => a.localeCompare(b));

  //       if (filteredSortedIds?.length > 0) {
  //         setVal({
  //           ...val,
  //           botIds: filteredSortedIds,
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching bot profiles:", error);
  //     }
  //   };

  //   fetchBotProfiles();
  // }, []);
  const hasValue = (value: any): boolean => {
    if (value === null || value === undefined) return false;

    if (typeof value === "string") {
      return value.trim() !== "" && value.trim() !== "-";
    }

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return true;
  };
  return (
    <>
      <div style={{
        paddingLeft: "40px", paddingRight: "40px", paddingBottom: "30px", display: "flex",
        flexDirection: "column",
        height: "-webkit-fill-available",
      }}>
        <Form  onSubmit={handleSubmit}>
          <Row style={{ alignItems: "flex-end", fontSize: "14px" }}>
            <Col sm={3} style={{ padding: 12 }}>
              <Form.Group>
                <Form.Label style={{ fontWeight: "700" }}>Start Date:</Form.Label>
                <Form.Control
                  name="startDate"
                  style={{ fontSize: "14px" }}
                  value={formValues.startDate}
                  onChange={handleDateChange}
                  placeholder="Start Date:"
                  max={formatDate()}
                  type="date"
                />
              </Form.Group>
            </Col>
            <Col sm={3} style={{ padding: 12 }}>
              <Form.Group>
                <Form.Label style={{ fontWeight: "700" }}>End Date:</Form.Label>
                <Form.Control
                  name="endDate"
                  style={{ fontSize: "14px" }}
                  value={formValues.endDate}
                  onChange={handleDateChange}
                  placeholder="End Date:"
                  max={formatDate()}
                  type="date"
                />
              </Form.Group>
            </Col>
            {/* bot profiles dropdown */}
            {/* <Col sm={"auto"} style={{ padding: 12 }}>
            <Dropdown onSelect={handleBotSelect}>
              <Dropdown.Toggle>
                {formValues.selectedBotId || "Select Bot ID"}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  maxHeight: "234px",
                  overflowY: "auto",
                  width: "-webkit-fill-available",
                }}
              >
                {val.botIds &&
                  val.botIds.map((id: any) => {
                    return (
                      <Dropdown.Item
                        key={id}
                        eventKey={id}
                        active={id === formValues.selectedBotId}
                      >
                        {id}
                      </Dropdown.Item>
                    );
                  })}
              </Dropdown.Menu>
            </Dropdown>
          </Col> */}
            <Col
              sm={"auto"}
              xs={6}
              style={{
                padding: 12,
                display: "flex",
                justifyContent: "flex-end",
                height: "fit-content",
              }}
            >
              <Button
                type="submit"
                style={{ fontSize: "14px" }}
                disabled={val.getReportLoader}
              >
                {val.getReportLoader && (
                  <span
                    className="spinner-border"
                    aria-hidden="true"
                    style={{
                      fontSize: "18px",
                      height: "18px",
                      width: "18px",
                      marginRight: "8px",
                    }}
                  ></span>
                )}
                Get Report
              </Button>
            </Col>

            <Col
              sm={"auto"}
              xs={6}
              style={{
                padding: 12,
                display: "flex",
                justifyContent: "flex-end",
                height: "fit-content",
              }}
            >
              <Button
                className="btn btn-success"
                style={{ fontSize: "14px" }}
                onClick={() => setVal({ ...val, openPublishPopup: true })}
                disabled={val.publishloader}
              >
                Publish
              </Button>
            </Col>
          </Row>
        </Form>

        <div
          style={{
            flex: "1",
            overflow: "auto",
            fontSize: "14px",

            // border: color === "dark" ? "" : "1px solid #ededed",
          }}
          className=" rounded-2"
          // data-bs-theme={`${color}`}
        >
          {!pageLoader ? (
            botDetailsData && rowData && botDetailsData?.result?.length > 0 ? (
              <>
                <div className="rounded-2">
                  <table
                    className="table table-striped table-hover learning-table"
                    style={{ marginBottom: "0px", marginTop: "0px" }}
                  >
                    <thead
                      className={`${color === "dark" ? "table-light" : "table-dark"
                        }`}
                    >
                      <tr>
                        <th
                          className="sticky-col sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;S.No&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;User Issue&nbsp;
                        </th>
                        {/* <th
                        className="sticky-header"
                        style={{ whiteSpace: "nowrap", width: "fit-content" }}
                      >
                        &nbsp;Channel&nbsp;
                      </th> */}
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Knowledge article/s referred by bot&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;KB helpful&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;User Feedback&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Ticket #&nbsp;
                        </th>
                        {/* <th
                        className="sticky-header"
                        style={{ whiteSpace: "nowrap", width: "fit-content" }}
                      >
                        &nbsp;Bot Transcript&nbsp;
                      </th> */}
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Work Notes&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Resolution Notes&nbsp;
                        </th>

                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Final Resolution&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Reviewer Feedback&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Reviewer Resolution&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Reviewer Selection&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Mention KB #&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Action&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Published KB #&nbsp;
                        </th>
                        <th
                          className="sticky-header"
                          style={{ whiteSpace: "nowrap", width: "fit-content" }}
                        >
                          &nbsp;Published Content&nbsp;
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ color: "black", height: "60px" }}>
                      {botDetailsData?.result?.map((data: any, index: number) => {
                        const isPublished =
                          hasValue(data?.published) &&
                          hasValue(data?.publishedContent);

                        return (
                          <tr key={index}>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                            }}
                            className="sticky-col"
                          >
                            {index + 1}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {data.UserIssue}
                          </td>

                          {/* <td
                          style={{
                            padding: "10px",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            verticalAlign: 'middle'
                          }}
                        >
                         
                          {data.Channel}
                       
                          
                        </td> */}


                          <td style={{ textAlign: "center" }}>
  {data.KB_numbers?.[0] || "-"}
</td>

                          <td>{data.KB_helpful ? "Yes" : "No"}</td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: 'middle'
                            }}
                          >

                            {data.UserFeedback}


                          </td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: 'middle',
                              minWidth: '150px'

                            }}
                          >
                            {data.ticket_number.toString()}
                          </td>
                          {/* <td
                          style={{
                            padding: "10px",
                            textAlign: "center",
                            verticalAlign: 'middle'
                          }}
                        >
                          <div>
                            <i
                              className="bi bi-eye-fill"
                              style={{ cursor: "pointer", fontSize: '20px' }}
                              onClick={() =>
                                setVal({
                                  ...val,
                                  openTranscript: true,
                                  transcript: data.transcript,
                                })
                              }
                            ></i>
                          </div>
                        </td> */}
                          <td
                            style={{
                              padding: "10px",
                              minWidth: "400px",
                            }}
                          >
                            <p
                              ref={(el) => {
                                if (!textRef.current['workNotes'][index]) textRef.current['workNotes'][index] = [];
                                textRef.current['workNotes'][index][0] = el;
                              }
                              }
                              className="clamp-lines"
                              style={{ margin: 0 }}
                            >
                              {data.Worknotes.toString()}
                            </p>
                            {visibleRows["workNotes"][index]?.[0] && (
                              <span
                                style={{ margin: 0, cursor: "pointer" }}
                                className="text-primary"
                                onClick={() =>
                                  setViewMore({
                                    type: "Worknotes",
                                    ticket_number: data.ticket_number,
                                    data: data.Worknotes.toString(),
                                  })
                                }
                              >
                                View More
                              </span>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              minWidth: "400px",
                            }}
                          >
                            <p
                              ref={(el) => {
                                if (!textRef.current['resolutionNotes'][index]) textRef.current['resolutionNotes'][index] = [];
                                textRef.current['resolutionNotes'][index][0] = el;
                              }
                              }
                              className="clamp-lines"
                              style={{ margin: 0 }}
                            >
                              {data.ResolutionNotes.toString()}
                            </p>
                            {visibleRows["resolutionNotes"][index]?.[0] && (
                              <span
                                style={{ margin: 0, cursor: "pointer" }}
                                className="text-primary"
                                onClick={() =>
                                  setViewMore({
                                    type: "Resolution Notes",
                                    ticket_number: data.ticket_number,
                                    data: data.ResolutionNotes.toString(),
                                  })
                                }
                              >
                                View More
                              </span>
                            )}
                          </td>

                          <td
                            style={{
                              padding: "10px",
                              minWidth: "400px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                // alignItems: "center",
                                // justifyContent: "center",
                                gap: "12px",
                                maxHeight: "231px",
                                // overflowY: "auto",
                              }}
                            >
                              <div>
                                <p
                                  ref={(el) => {
                                    if (!textRef.current['botResolution'][index]) textRef.current['botResolution'][index] = [];
                                    textRef.current['botResolution'][index][0] = el;
                                  }
                                  }
                                  className="clamp-lines"
                                  style={{ margin: 0 }}
                                >
                                  {data.botResolution}
                                </p>

                                {visibleRows["botResolution"][index]?.[0] && (
                                  <span
                                    style={{ margin: 0, cursor: "pointer" }}
                                    className="text-primary"
                                    onClick={() =>
                                      setViewMore({
                                        type: "Final Resolution",
                                        ticket_number: data.ticket_number,
                                        data: data.botResolution,
                                      })
                                    }
                                  >
                                    View More
                                  </span>
                                )}
                              </div>

                              {data.botResolution && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    copyToClipboard(data.botResolution, index)
                                  }
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "35px",
                                    width: "35px",
                                    borderRadius: "50%",
                                  }}
                                  className={`btn btn-${color}`}
                                >
                                  <i
                                    className={`bi bi-${isCopied === index ? "check" : "copy"
                                      }`}
                                    title="Copy to clipboard"
                                  ></i>
                                </button>
                              )}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                              <select
                                name="feedback"
                                id={`feedback-${index}`}
                                disabled={isPublished}
                                title={
                                  isPublished
                                    ? "Reviewer feedback is disabled because this record is already published"
                                    : ""
                                }
                                style={{
                                  margin: 0,
                                  fontSize: "14px",
                                  cursor: isPublished ? "not-allowed" : "pointer",
                                  opacity: isPublished ? 0.6 : 1,
                                }}
                                value={rowData[index]?.feedback || ""}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  setRowData((prev) => {
                                    const updated = [...prev];

                                    updated[index] = {
                                      ...updated[index],
                                      feedback: value,
                                    };

                                    return updated;
                                  });
                                }}
                              >
                                <option value="">Select</option>

                                {options1.map((option: any, idx: number) => (
                                  <option key={idx} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                          </td>
                          <td
                            style={{
                              whiteSpace: "nowrap",
                              padding: "10px",
                              verticalAlign: 'middle'
                            }}
                          >
                            <div style={{ verticalAlign: "top", height: '-webkit-fill-available' }}>
                                <textarea
                                  style={{
                                    outline: "none",
                                    minWidth: "300px",
                                    fontSize: "14px",
                                    height: "-webkit-fill-available",
                                    cursor: isPublished ? "not-allowed" : "text",
                                    opacity: isPublished ? 0.6 : 1,
                                  }}
                                  id={`botRes${index}`}
                                  disabled={isPublished}
                                  title={
                                    isPublished
                                      ? "Reviewer remarks are disabled because this record is already published"
                                      : ""
                                  }
                                  value={rowData[index]?.reviewerResolution || ""}
                                  onChange={(e) => {
                                    setRowData((prevRowData) => {
                                      if (!prevRowData[index]) {
                                        console.warn(`Row index ${index} not found in rowData`);
                                        return prevRowData;
                                      }

                                      const updated = [...prevRowData];

                                      updated[index] = {
                                        ...updated[index],
                                        reviewerResolution: e.target.value,
                                      };

                                      return updated;
                                    });
                                  }}
                                />
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <select
                              name="reviewer"
                              id="reviewer"
                              disabled={isPublished}
                              title={
                                isPublished
                                  ? "Reviewer feedback is disabled because this record is already published"
                                  : ""
                              }
                              style={{
                                margin: 0,
                                fontSize: "14px",
                                cursor: isPublished ? "not-allowed" : "pointer",
                                opacity: isPublished ? 0.6 : 1,
                              }}
                              value={rowData[index]?.reviewer || "Select"}
                              onChange={(e) => {
                                const value = e.target.value;

                                setRowData((prev) => {
                                  const updated = [...prev];
                                  const currentRow = updated[index] || {};

                                  updated[index] = {
                                    ...currentRow,
                                    reviewer: value,
                                    kb: value === "new_customKb" ? "" : currentRow?.kb || ""
                                  };
                                  return updated;
                                });
                              }}
                            >
                              <option value="Select">Select</option>
                              {options2.map((val: any, idx: number) => (
                                <option key={idx} value={val.value}>
                                  {val.label}
                                </option>
                              ))}
                            </select>

                          </td>
                          <td
                            style={{
                              whiteSpace: "nowrap",
                              padding: "10px",
                              verticalAlign: "middle",
                            }}
                          >
                            <input
                              style={{ height: "45px", fontSize: "14px" ,
                                  cursor: isPublished ? "not-allowed" : "text",
                                  opacity: isPublished ? 0.6 : 1,
                               }}
                              id={"kbNo" + index}
                              disabled={
                                  isPublished ||
                                  rowData[index]?.reviewer === "new_customKb"
                                }
                                title={
                                  isPublished
                                    ? "Reviewer remarks are disabled because this record is already published"
                                    : rowData[index]?.reviewer === "new_customKb"
                                    ? "Reviewer remarks are disabled for custom KB records"
                                    : ""
                              }
                              required={rowData[index]?.reviewer === "extra_info"}
                              value={rowData[index]?.kb || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                // const updated = [...rowData];
                                // updated[index].kb = e.target.value;
                                // setRowData(updated);
                                setRowData((prev) => {
                                  const updated = [...prev];
                                  const currentRow = updated[index] || {};

                                  updated[index] = {
                                    ...currentRow,
                                    kb: value,
                                  };
                                  return updated;
                                })
                              }}
                            ></input>
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          ><span
                            title={
                              !rowData[index]?.reviewerResolution?.trim() &&
                                rowData[index]?.reviewer === "extra_info" &&
                                !rowData[index]?.kb?.trim() ? "Fill Reviewer Resolution and mention KB Number"
                                : rowData[index]?.reviewer !== "extra_info" && rowData[index]?.reviewer !== "custom_Kb" ? "Select Reviewer Selection"
                                  : !rowData[index]?.reviewerResolution?.trim() ? "Fill Reviewer Resolution"
                                    : rowData[index]?.reviewer === "extra_info" && !rowData[index]?.kb?.trim() ? "Mention KB Number"
                                      : ""
                            }
                            style={{
                              display: "inline-block",
                              cursor: loadingIndex === index ||
                                !rowData[index]?.reviewerResolution?.trim() ||
                                (!rowData[index]?.reviewerResolution?.trim() &&
                                  rowData[index]?.reviewer !== "extra_info" &&
                                  rowData[index]?.reviewer !== "new_customKb"
                                ) ||
                                (
                                  rowData[index]?.reviewer === "extra_info" &&
                                  !rowData[index]?.kb?.trim()
                                )
                                ? "not-allowed" : "pointer",
                            }}
                          >
                              <button
                                id={"submitBtn" + index}
                                className="btn btn-primary btnSubmit"
                                color="black"
                                style={{ fontSize: "14px" }}

                                // disabled={loadingIndex === index ||
                                //   !rowData[index]?.reviewerResolution?.trim() ||
                                //   (!rowData[index]?.reviewerResolution?.trim() &&
                                //     rowData[index]?.reviewer !== "extra_info" &&
                                //     rowData[index]?.reviewer !== "new_customKb"
                                //   ) ||
                                //   (
                                //     rowData[index]?.reviewer === "extra_info" &&
                                //     !rowData[index]?.kb?.trim()
                                //   )
                                // }
                                onClick={() => {
                                  setLoadingIndex(index);
                                  handleUpdateClick(
                                    rowData[index],
                                    data.conversation_id
                                  );
                                }}
                                autoFocus
                              >
                                {loadingIndex === index && (
                                  <div
                                    style={{
                                      fontSize: "18px",
                                      height: "18px",
                                      width: "18px",
                                      marginRight: "8px",
                                    }}
                                    className="spinner-border"
                                    role="status"
                                  ></div>
                                )}
                                Update
                              </button>
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {data.published}
                          </td>
                          <td style={{ padding: "10px" }}>
                            <p
                              ref={(el) => {
                                if (!textRef.current['publishedContent'][index]) textRef.current['publishedContent'][index] = [];
                                textRef.current['publishedContent'][index][0] = el;
                              }
                              }
                              className="clamp-lines"
                              style={{ margin: 0 }}
                            >
                              {data.publishedContent}
                            </p>

                            {visibleRows["publishedContent"][index]?.[0] && (
                              <span
                                style={{ margin: 0, cursor: "pointer" }}
                                className="text-primary"
                                onClick={() =>
                                  setViewMore({
                                    type: "Final Resolution",
                                    ticket_number: data.ticket_number,
                                    data: data.publishedContent,
                                  })
                                }
                              >
                                View More
                              </span>
                            )}
                          </td>
                        </tr>
                        );

                      })}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  height: "100%",
                }}
              >
                <i
                  className="bi bi-file-earmark-x"
                  style={{ fontSize: "30px" }}
                ></i>
                <p style={{ margin: 0 }}> No Data Available</p>
              </div>
            )
          ) : (
            <div
              style={{
                height: "-webkit-fill-available",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  height: "18px",
                  width: "18px",
                  marginRight: "8px",
                }}
                className="spinner-border"
                role="status"
              ></div>
            </div>
          )}

          {val.openTranscript && (
            <div
              className="modal fade show d-block"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              tabIndex={-1}
            >
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <i
                        style={{ marginRight: "12px" }}
                        className="bi bi-chat-square-text-fill"
                      ></i>
                      Chat Transcript
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setVal({ ...val, openTranscript: false })}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ margin: 0, color: "black" }}
                  >
                    {val.transcript.length !== 0 ? (
                      <table
                        style={{
                          fontSize: "13px",
                          textAlign: "left",
                          width: "-webkit-fill-available",
                        }}
                      >
                        <tbody>
                          {val?.transcript?.map((d: any, i: any) => (
                            <tr
                              key={i}
                              style={{
                                backgroundColor:
                                  d.requester === "User" ? "#DEF2FF" : "#B3E2FF",
                                border: "1px solid black",
                              }}
                            >
                              <td
                                style={{
                                  padding: "10px",
                                  verticalAlign: "top",
                                  fontWeight: "bold",
                                }}
                              >
                                {d.requester}:
                              </td>
                              <td style={{ padding: "10px" }}>
                                {d.bot_response}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  width: "150px",
                                  verticalAlign: "top",
                                  fontSize: "11px",
                                }}
                              >
                                {d.timestamp.substring(11, 19) +
                                  ", " +
                                  d.timestamp.substring(0, 10)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div>No data available</div>
                    )}
                  </div>
                  <div
                    className="modal-footer"
                    style={{ justifyContent: "flex-end" }}
                  >
                    <button
                      type="button"
                      style={{
                        width: "fit-content",
                        lineHeight: "normal",
                        height: "fit-content",
                        display: "flex",
                        gap: "8px",
                      }}
                      className="btn btn-secondary"
                      onClick={() => setVal({ ...val, openTranscript: false })}
                    >
                      <i className="bi bi-x-circle"></i>
                      Close
                    </button>
                    {val.transcript.length !== 0 && (
                      <button
                        type="button"
                        style={{
                          width: "fit-content",
                          lineHeight: "normal",
                          height: "fit-content",
                          display: "flex",
                          gap: "8px",
                        }}
                        className="btn btn-success"
                        onClick={exportChatTranscript}
                      >
                        <i className="bi bi-download"></i>Export As XLSX
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* pagination */}
        {botDetailsData?.result?.length > 0 && !pageLoader && (
          <div
            data-bs-theme={`${color}`}
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "flex-end",
              flexWrap: "wrap",
              gap: "8px",
              paddingTop: "15px"
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <div style={{ width: "28%", float: "left" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: "14px",
                  }}
                >
                  Showing {frstIndx} to{" "}
                  {lastIndx > botDetailsData?.totalRecords
                    ? botDetailsData?.totalRecords
                    : lastIndx}{" "}
                  of {botDetailsData?.totalRecords}
                </div>
              </div>
              <nav>
                <ul className="pagination" style={{ margin: 0 }}>
                  <li className={`page-item ${currPage == 1 ? "disabled" : ""}`}>
                    <button
                      className="btn btn-primary page-link"
                      style={{ fontSize: "14px" }}
                      onClick={prevPage}
                    >
                      Prev
                    </button>
                  </li>

                  {botDetailsData ? renderPageNumbers() : ""}

                  <li
                    className={`page-item ${currPage == totalPages ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="btn btn-primary page-link"
                      style={{ fontSize: "14px" }}
                      onClick={nxtPage}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            <button
              type="button"
              className="btn btn-success"
              title="Export as XLSX"
              style={{
                width: "fit-content",
                height: "38px",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                gap: "4px",
                fontSize: "14px",
              }}
              onClick={() =>
                exportAsXlsx(botDetailsData?.totalRecords, formValues)
              }
            >
              Export as XLSX
              <i className="bi bi-filetype-xlsx" style={{ fontSize: "24px" }}></i>
            </button>
          </div>
        )}

        {/* -- View More Modal */}
        {viewMore && (
          <div
            className="modal fade show d-block"
            id="viewmore"
            data-bs-theme={color}
            tabIndex={-1}
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div
                className="modal-content"
                style={{ margin: "0px", whiteSpace: "pre-line" }}
              >
                <div className="modal-header" style={{ fontSize: "14px" }}>
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    {viewMore.type}: #{viewMore.ticket_number}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setViewMore(null)}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{ margin: "0px", fontSize: "14px" }}
                >
                  {viewMore.data}
                </div>
                <div
                  className="modal-footer"
                  style={{ justifyContent: "flex-end" }}
                >
                  <button
                    type="button"
                    style={{
                      width: "fit-content",
                      justifyContent: "flex-end",
                      fontSize: "14px",
                    }}
                    className="btn btn-secondary"
                    onClick={() => setViewMore(null)}
                  >
                    <i
                      style={{ marginRight: "8px" }}
                      className="bi bi-x-circle"
                    ></i>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* bootstrap toast for alert messages       */}
        <div
          className={`toast position-absolute start-50 translate-middle-x align-items-center text-bg-${toastType} border-0 ${showToast ? "show" : "hide"
            } `}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body">{toastMessage}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
        </div>

        {/* {val.open && (
        <EditDetails
          data-bs-theme={`${color}`}
          onClose={() => setVal({ ...val, open: false })}
          loader={val.updateLoader}
          setUpdatedKbText={setUpdatedKbText}
          onUpdate={handleUpdate}
          state="updateDashboardDetails"
        />
      )} */}

        {val.openPublishPopup && (
          <EditDetails
            onClose={() => setVal({ ...val, openPublishPopup: false })}
            onPublish={publishDetails}
            state="publish"
            loader={val.publishloader}
          />
        )}
      </div>
    </>
  );
};

export default LearningDashboardSection;